export const props = Object.freeze({
  /**
   * The search result object. A Physician or Location payload (the row infers the type from
   * `resultType`, falling back to whether `physician_image_urls` is present). Object props have no
   * attribute form — set this as a DOM property (`.prop` in a template, `el.result = …` in script).
   *
   * @type {Object}
   * @storybook-control object
   * @default {}
   */
  result: {
    type: Object,
    default: () => ({}),
  },
  /**
   * Per-deployment display flags. `resultTemplate: "directory"` enables the wide directory layout;
   * the `showProvider*` booleans toggle individual attributes; `showProviderHoursBadge` fetches and
   * renders the location hours badge. Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default undefined
   */
  resultConfig: {
    type: Object,
    default: undefined,
  },
  /**
   * Localised label strings for accepting-patients, LGBTQIA+ affirming care, and video-visit tiles.
   * Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default {}
   */
  labels: {
    type: Object,
    default: () => ({}),
  },
});
